const initialState = {
    fetching: false,
    fetch: false,
    error: false,
    url: '',
};

export default initialState;
